// Query hook - lista zalacznikow transakcji
// GET /api/ui/sales-crm/deals/{id}/attachments

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IGetDealAttachmentsResponse } from 'api/types/deals';

const getDealAttachments = (id: number): Promise<IGetDealAttachmentsResponse> =>
  axios.get(`/sales-crm/deals/${id}/attachments`);

export const useGetDealAttachments = (
  id: number,
  options?: UseQueryOptions<IGetDealAttachmentsResponse, IError>,
) =>
  useQuery<IGetDealAttachmentsResponse, IError>(
    ['sales-crm-deal-attachments', id],
    () => getDealAttachments(id),
    {
      enabled: id > 0,
      ...options,
    },
  );
